import { useEffect, useState } from 'react';
import { useAuth } from '../../hooks/useAuth';
import { AxiosError, isAxiosError } from 'axios';
// import { IError } from "../../interfaces/IError";
import { useNotification } from '../../providers/NotificationProvider';
import { NotificationStatus } from '../notification/Notification';

interface IProps {
    epgId: number;
}

export const RecordButton = ({ epgId }: IProps) => {
    const [isActive, setIsActive] = useState(true);
    const _authService = useAuth();
    const _notificationService = useNotification();

    const createRecording = async () => {
        try {
            // await api.createRecording(epgId);
            _notificationService.showNotification('Powodzenie', 'Nagranie zostało zlecone.', NotificationStatus.success);
            setIsActive(true);
        } catch (error) {
            const axiosError = error as AxiosError | Error;
            if (isAxiosError(axiosError)) {
                console.log();
                // const error = axiosError?.response?.data as IError;
            }
            _notificationService.showNotification('Niepowodzenie', 'Coś poszło nie tak. Spróbuj ponownie za kilka minut.', NotificationStatus.failure);
        }
    };

    const deleteRecording = async () => {
        try {
            // await api.deleteRecording(epgId);
            _notificationService.showNotification('Powodzenie', 'Nagranie zostało usunięte.', NotificationStatus.success);
            setIsActive(false); // Update: False to reflect recording deletion
        } catch (error) {
            const axiosError = error as AxiosError | Error;
            if (isAxiosError(axiosError)) {
                // const error = axiosError?.response?.data as IError;
            }
            _notificationService.showNotification('Niepowodzenie', 'Coś poszło nie tak. Spróbuj ponownie za kilka minut.', NotificationStatus.failure);
        }
    };

    useEffect(() => {
        if (_authService.user && _authService.user.recordingIds && _authService.user.recordingIds.includes(epgId))
            setIsActive(true);
        return () => {
            setIsActive(false);
        };
    }, [epgId, _authService.user?.recordingIds]);

    return (
        <>
            {_authService.token &&
                <button onClick={() => isActive ? deleteRecording() : createRecording()}
                        className={`bg-neutral-800 px-3 pr-4 py-2 transition-colors shrink-0  ring-offset-neutral-700 focus:outline-hidden focus:ring-offset-neutral-700 flex items-center border-0 border-red-500 rounded-full space-x-2 mb-2 cursor-pointer hover:bg-neutral-900 `}>
                    <div className="w-4 h-4 rounded-full bg-neutral-300 relative shrink-0 ml-0.5">
                        <div
                            className={`w-3.5 h-3.5 ${isActive ? 'bg-red-500' : 'bg-neutral-500'} rounded-full absolute left-1/2 -translate-x-1/2 top-1/2 -translate-y-1/2 transition-colors duration-300`} />
                    </div>
                    <p className={`animate-opacityEaseIn`}>Nagraj</p>
                </button>
            }
        </>
    );
};
